export interface Language {
  code: string;
  name: string;
  flag: string;
  file: string;
}

export const AVAILABLE_LANGUAGES: Language[] = [
  {
    code: 'it_IT',
    name: 'Italiano',
    flag: '🇮🇹',
    file: 'it_IT.json'
  },
  {
    code: 'en_GB', 
    name: 'English (UK)',
    flag: '🇬🇧',
    file: 'en_GB.json'
  },
  {
    code: 'de_DE',
    name: 'Deutsch',
    flag: '🇩🇪',
    file: 'de_DE.json'
  },
  {
    code: 'fr_FR',
    name: 'Français',
    flag: '🇫🇷',
    file: 'fr_FR.json'
  }
];

export const DEFAULT_LANGUAGE = 'it_IT';

// Funzione per ottenere la lingua del browser
export const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || navigator.languages?.[0] || DEFAULT_LANGUAGE;
  
  // Mappa delle lingue del browser ai nostri codici
  const languageMap: Record<string, string> = {
    'it': 'it_IT',
    'it-IT': 'it_IT',
    'en': 'en_GB',
    'en-GB': 'en_GB',
    'en-US': 'en_GB', // Mappiamo anche US a GB per ora
    'de': 'de_DE',
    'de-DE': 'de_DE',
    'de-AT': 'de_DE', // Austria usa il tedesco
    'de-CH': 'de_DE', // Svizzera tedesca
    'fr': 'fr_FR',
    'fr-FR': 'fr_FR',
    'fr-CA': 'fr_FR', // Canada francese
    'fr-BE': 'fr_FR', // Belgio francese
    'fr-CH': 'fr_FR', // Svizzera francese
  };
  
  // Cerca corrispondenza esatta prima
  if (languageMap[browserLang]) {
    return languageMap[browserLang];
  }
  
  // Poi cerca solo la parte del codice lingua (es. 'it' da 'it-CH')
  const langCode = browserLang.split('-')[0];
  if (languageMap[langCode]) {
    return languageMap[langCode];
  }
  
  return DEFAULT_LANGUAGE;
};

// Funzione per verificare se una lingua è disponibile
export const isLanguageAvailable = (langCode: string): boolean => {
  return AVAILABLE_LANGUAGES.some(lang => lang.code === langCode);
};

// Funzione per ottenere i dettagli di una lingua
export const getLanguageDetails = (langCode: string): Language | undefined => {
  return AVAILABLE_LANGUAGES.find(lang => lang.code === langCode);
};